import React, { useState, useRef, useEffect } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { showCreateForm } from "../../redux/features/purchaseSlice";
import { showReportForm } from "../../redux/features/materialSlice";

const NavMaterial = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="flex hover:text-white font-bold p-1"
      >
        گدام مواد خام
        <RiArrowDropDownLine size={24} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-300 rounded shadow-md z-50">
          {/* <button
            onClick={() => dispatch(showCreateForm())}
            className="block w-full text-start px-4 py-1 text-gray-800 hover:bg-gray-200"
          >
            اضافه کردن
          </button> */}
          <Link
            to="/materials"
            className="block px-4 py-1 text-gray-800 hover:bg-gray-200"
          >
            لیست مواد خام
          </Link>
          <Link
            to="/materials-min"
            className="block px-4 py-1 text-gray-800 hover:bg-gray-200"
          >
            لیست رو به اتمام
          </Link>
          <hr />
          <button
            onClick={() => dispatch(showReportForm())}
            className="block w-full text-start px-4 py-2 text-gray-800 hover:bg-gray-200"
          >
            تهیه گذارش مواد خام
          </button>
        </div>
      )}
    </div>
  );
};

export default NavMaterial;
